export default __webpack_public_path__ + "static/media/it-21.27827cdd.svg";